import { render, staticRenderFns } from "./step-confirm.vue?vue&type=template&id=45f693b2&"
import script from "./step-confirm.vue?vue&type=script&lang=js&"
export * from "./step-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports